// Mock data for Gateway Sistemas Landing Page
// This file contains all the static data used throughout the application

export const companyInfo = {
  name: "Gateway Sistemas",
  foundedYear: 1994,
  yearsOfExperience: new Date().getFullYear() - 1994,
  phone: "(15) 9 8165-1506",
  landlinePhone: "(15) 3271-3786",
  whatsapp: "5515991089431",
  resellerWhatsapp: "5515996594981",
  website: "https://gatewaysistemas.com.br",
  xmlDownloadUrl: "/xml",
  systemAccessUrl: "https://gatewaysistemas.com.br/gway/#/gwaysistemas/",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_eda8ca4d-c957-4325-a9ab-0a26f5df1d41/artifacts/2jmiflv8_Gateway_500_200_2_C.png",
  address: {
    street: "Avenida Nisshimbo do Brasil, 531 - Central Parque 4L",
    city: "Itapetininga",
    state: "São Paulo",
    zipCode: "18000-815",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.2044095022484!2d-48.057804784961995!3d-23.59700098466518!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c5cc99f5739653%3A0x5f0f824086bdc67a!2sGateway+Sistemas!5e0!3m2!1spt-BR!2sbr!4v1537022191449",
  },
};

export const supportTools = {
  teamviewer: {
    name: "TeamViewer",
    description: "Acesso remoto rápido e seguro",
    downloadUrl:
      "https://gatewaysistemas.com.br/Gateway/downloads/TeamViewerQS_pt-idcwadwrwr.exe",
  },
  anydesk: {
    name: "AnyDesk",
    description: "Alternativa de suporte remoto",
    downloadUrl: "https://gatewaysistemas.com.br/Gateway/downloads/AnyDesk.exe",
  },
};

export const institutionalText = {
  title: "A Gateway",
  content: [
    "Pioneira no ramo de negócios para negócios no interior do estado de São Paulo, a Gateway Sistemas é uma empresa sólida atuante no mercado a mais de 30 anos (fundada em 1994), sempre com integridade e transparência.",
    "Nossas soluções são perfeitas para tornar nossos clientes cada vez mais competitivos no segmento atuante, com sistemas de fácil utilização e que garantem o total controle da sua empresa.",
  ],
  mission:
    "Fornecer soluções tecnológicas inovadoras e acessíveis que simplificam a gestão empresarial, permitindo que pequenos e micro empreendedores foquem no crescimento de seus negócios.",
};

export const pricingPlans = [
  {
    id: "emissor",
    name: "G-way Emissor",
    price: "R$ 25,00",
    popular: false,
    features: [
      { name: "Arquivos XML", included: true },
      { name: "NF-e", included: true },
      { name: "NFC-e / SAT", included: true },
      { name: "NFS-e", included: true },
      { name: "MDF-e", included: true },
      { name: "CT-e", included: true },
      { name: "Retaguarda do Frente de Caixa", included: false },
      { name: "Backup automático", included: true },
      { name: "Relatórios personalizáveis", included: true },
      { name: "App Relatórios Móveis", included: false },
      { name: "Ordem de Serviço", included: false },
      { name: "Pedido de Venda", included: false },
      { name: "App Força de Vendas", included: false },
      { name: "Pedido de Compra", included: false },
      { name: "Restaurante", included: false },
      { name: "App Restaurante (Garçom)", included: false },
      { name: "Financeiro", included: false },
      { name: "Emissão de Boletos", included: false },
      { name: "SPED e Sintegra", included: true },
      { name: "Integração de Filiais", included: false },
      { name: "Controle Industrial e Obras", included: false },
      { name: "Lucro Real / Presumido", included: false },
    ],
  },
  {
    id: "gestor-fit",
    name: "G-way Gestor Fit",
    price: "R$ 40,00",
    popular: false,
    features: [
      { name: "Arquivos XML", included: true },
      { name: "NF-e", included: true },
      { name: "NFC-e / SAT", included: true },
      { name: "NFS-e", included: true },
      { name: "MDF-e", included: true },
      { name: "CT-e", included: true },
      { name: "Retaguarda do Frente de Caixa", included: false },
      { name: "Backup automático", included: true },
      { name: "Relatórios personalizáveis", included: true },
      { name: "App Relatórios Móveis", included: false },
      { name: "Ordem de Serviço", included: false },
      { name: "Pedido de Venda", included: false },
      { name: "App Força de Vendas", included: false },
      { name: "Pedido de Compra", included: false },
      { name: "Restaurante", included: false },
      { name: "App Restaurante (Garçom)", included: false },
      { name: "Financeiro", included: true },
      { name: "Emissão de Boletos", included: false },
      { name: "SPED e Sintegra", included: true },
      { name: "Integração de Filiais", included: false },
      { name: "Controle Industrial e Obras", included: false },
      { name: "Lucro Real / Presumido", included: false },
    ],
  },
  {
    id: "gestor-pro",
    name: "G-way Gestor Pro",
    price: "R$ 60,00",
    popular: true,
    features: [
      { name: "Arquivos XML", included: true },
      { name: "NF-e", included: true },
      { name: "NFC-e / SAT", included: true },
      { name: "NFS-e", included: true },
      { name: "MDF-e", included: true },
      { name: "CT-e", included: true },
      { name: "Retaguarda do Frente de Caixa", included: true },
      { name: "Backup automático", included: true },
      { name: "Relatórios personalizáveis", included: true },
      { name: "App Relatórios Móveis", included: true },
      { name: "Ordem de Serviço", included: true },
      { name: "Pedido de Venda", included: true },
      { name: "App Força de Vendas", included: true },
      { name: "Pedido de Compra", included: true },
      { name: "Restaurante", included: true },
      { name: "App Restaurante (Garçom)", included: true },
      { name: "Financeiro", included: true },
      { name: "Emissão de Boletos", included: true },
      { name: "SPED e Sintegra", included: true },
      { name: "Integração de Filiais", included: true },
      { name: "Controle Industrial e Obras", included: false },
      { name: "Lucro Real / Presumido", included: true },
    ],
  },
  {
    id: "industria",
    name: "G-way Indústria",
    price: "R$ 100,00",
    popular: false,
    features: [
      { name: "Arquivos XML", included: true },
      { name: "NF-e", included: true },
      { name: "NFC-e / SAT", included: true },
      { name: "NFS-e", included: true },
      { name: "MDF-e", included: true },
      { name: "CT-e", included: true },
      { name: "Retaguarda do Frente de Caixa", included: false },
      { name: "Backup automático", included: true },
      { name: "Relatórios personalizáveis", included: true },
      { name: "App Relatórios Móveis", included: true },
      { name: "Ordem de Serviço", included: true },
      { name: "Pedido de Venda", included: true },
      { name: "App Força de Vendas", included: true },
      { name: "Pedido de Compra", included: true },
      { name: "Restaurante", included: true },
      { name: "App Restaurante (Garçom)", included: true },
      { name: "Financeiro", included: true },
      { name: "Emissão de Boletos", included: true },
      { name: "SPED e Sintegra", included: true },
      { name: "Integração de Filiais", included: false },
      { name: "Controle Industrial e Obras", included: true },
      { name: "Lucro Real / Presumido", included: true },
    ],
  },
];

export const businessSegments = [
  "Açougues",
  "Adegas",
  "Assistência técnica",
  "Atacados",
  "Autoelétricas",
  "Autopeças",
  "Bares",
  "Bazar",
  "Bicicletarias",
  "Bijuterias",
  "Borracharias",
  "Brinquedos",
  "Calçados",
  "Confecções",
  "Conveniências",
  "Distribuidoras",
  "Eletrodomésticos",
  "Esportes",
  "Ferragens",
  "Floriculturas",
  "Indústria",
  "Informática",
  "Joalherias",
  "Lanchonetes",
  "Livrarias",
  "Lubrificantes",
  "Manutenção",
  "Materiais de construção",
  "Materiais elétricos",
  "Mecânicas",
  "Mercados",
  "Móveis",
  "Oficinas",
  "Óticas",
  "Padarias",
  "Papelarias",
  "Perfumarias",
  "Pneus",
  "Presentes",
  "Prestadores de serviços",
  "Produtor rural",
  "Relojoarias",
  "Restaurantes",
  "Salões de beleza",
  "Som e imagem",
  "Supermercados",
  "Telefonia e celular",
  "Tintas",
  "Transportadoras",
  "Vendas externas",
  "Vidraçarias",
];

export const faqItems = [
  {
    id: "nfe-emission",
    question: "Como faço para emitir uma NF-e?",
    answer:
      'Para emitir uma NF-e, acesse o módulo de vendas, selecione o cliente, adicione os produtos ou serviços, configure os dados fiscais e clique em "Transmitir NF-e". O sistema fará toda a comunicação com a SEFAZ automaticamente.',
  },
  {
    id: "multiple-branches",
    question: "Posso usar o sistema em múltiplas filiais?",
    answer:
      "Sim! Os planos Gestor Pro e Indústria incluem integração entre filiais, permitindo controle centralizado de estoque, vendas e relatórios consolidados de todas as unidades.",
  },
  {
    id: "automatic-backup",
    question: "Como funciona o backup automático?",
    answer:
      "O sistema realiza backup automático diário dos seus dados, armazenando-os de forma segura. Você pode configurar horários personalizados e também fazer backups manuais quando necessário.",
  },
  {
    id: "offline-functionality",
    question: "O sistema funciona offline?",
    answer:
      "Sim, oferecemos tanto a versão desktop (que funciona offline) quanto a versão web. A versão desktop permite trabalhar sem internet, sincronizando os dados quando a conexão for restabelecida.",
  },
  {
    id: "plan-differences",
    question: "Qual a diferença entre os planos?",
    answer:
      "O Emissor é focado apenas em documentos fiscais. O Gestor Fit adiciona controle financeiro. O Gestor Pro inclui gestão completa com apps móveis e PDV. O Indústria tem controles específicos para indústrias.",
  },
];

export const features = {
  fiscal: [
    "NF-e (Nota Fiscal Eletrônica)",
    "NFC-e (Nota Fiscal do Consumidor Eletrônica)",
    "CT-e (Conhecimento de Transporte Eletrônico)",
    "MDF-e (Manifesto de Documentos Fiscais)",
    "NFS-e (Nota Fiscal de Serviços)",
    "SPED Fiscal e Contribuições",
    "Sintegra",
  ],
  management: [
    "Contas a Pagar e Receber",
    "Fluxo de Caixa",
    "Controle de Estoque",
    "Pedidos de Venda e Compra",
    "Relatórios Gerenciais",
    "Backup Automático",
    "Integração entre Filiais",
  ],
};

export const resellerBenefits = [
  {
    title: "Suporte Completo",
    description:
      "Treinamento, materiais de marketing e suporte técnico especializado para nossos revendedores.",
    icon: "Users",
  },
  {
    title: "Comissões Atrativas",
    description:
      "Sistema de comissionamento competitivo com bonificações por volume de vendas.",
    icon: "BarChart3",
  },
  {
    title: "Território Exclusivo",
    description:
      "Protegemos seu investimento com territórios exclusivos para revendedores cadastrados.",
    icon: "Building2",
  },
];

export const carouselSlides = [
  {
    id: 1,
    title: "Colaboração em Equipe",
    description:
      "Sua equipe conectada com ferramentas que facilitam a gestão e aumentam a produtividade.",
    image:
      "img/photo-1600880292089-90a7e086ee0c.jpg",
    ctaText: "Conheça Nossos Sistemas",
    ctaAction: "solutions",
  },
  {
    id: 2,
    title: "Pronto para a Reforma Tributária",
    description:
      "Nossa aplicação já está preparada para atender todas as demandas da nova reforma tributária brasileira.",
    image:
      "img/photo-1573164713988-8665fc963095.jpg",
    ctaText: "Saiba Mais",
    ctaAction: "solutions",
  },
  {
    id: 3,
    title: "Parcerias Estratégicas",
    description:
      "Junte-se à nossa rede de revendedores e multiplique seus resultados com nossas soluções ERP.",
    image:
      "img/photo-c4978cbb-760e-43dd-a1c5-2c4e195908c6.jpg",
    ctaText: "Seja um Parceiro",
    ctaAction: "reseller",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Maria Santos",
    business: "Empreendedora",
    content:
      "Com o Gateway, nossa gestão ficou muito mais organizada. Emissão de notas fiscais é rápida e sem complicações. Recomendo!",
    rating: 5,
    image:
      "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face",
  },
  {
    id: 2,
    name: "João Silva",
    business: "Empresário",
    content:
      "30 anos usando o sistema Gateway. Sempre atualizando, sempre funcionando. É uma parceria que deu muito certo!",
    rating: 5,
    image:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
  },
  {
    id: 3,
    name: "Ana Costa",
    business: "Restaurante",
    content:
      "O módulo restaurante é perfeito! Controle de mesas, pedidos e financeiro tudo integrado. Facilitou muito nossa operação.",
    rating: 5,
    image:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
  },
  {
    id: 4,
    name: "Carlos Mendes",
    business: "Indústria",
    content:
      "Sistema robusto para indústria. Controle de produção, custos e documentos fiscais. Tudo que precisamos em um só lugar.",
    rating: 5,
    image:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
  },
];
